import PaymentForm from 'components/Forms/PaymentForm/PaymentForm';
import Banner from 'components/ui/ContentBlocks/Banner';
import Layout from 'components/ui/Layout';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import styles from './PaymentUpdatePage.module.scss';
import type { Brand } from 'types/Brand';
import type { PaymentInformationPayload, SubmitResponse } from 'types/Payment';

type Props = {
  brand: Brand | null;
};

const PaymentUpdatePage = ({ brand }: Props): JSX.Element => {
  const { asPath } = useRouter();

  useEffect(() => {
    window.location.assign(
      `${process.env.NEXT_PUBLIC_PATIENT_JOURNEY_DOMAIN}${asPath}`,
    );
  }, [asPath]);

  const updatePaymentInformation = async (
    id: string,
    payload: PaymentInformationPayload,
  ): Promise<SubmitResponse | null> => {
    const response = await fetch(`/api/account?jid=${id}`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    if (response) {
      const data = await response.json();
      if (data) {
        const { hasResult, result } = data;
        if (hasResult && result) {
          return {
            success: true,
          };
        }
      }
    }

    return null;
  };

  return (
    <Layout
      title={`Update payment information | ${brand?.name}`}
      metaDescription="Update payment information"
      alternateSlugs={[]}
      footer={null}
      reducedFooter
      reducedHeader
      searchIndex={false}
      searchFollow={false}
      brand={brand}
    >
      <Banner
        blockId="payment-update-banner"
        preTitle="Update payment information"
        title="Update payment information"
        theme="dark"
      />
      <div className={styles.wrapper}>
        <PaymentForm onSubmit={updatePaymentInformation} page="PaymentUpdate" />
      </div>
    </Layout>
  );
};

export default PaymentUpdatePage;
